// Mods that ship with the game, off until you turn them on in Settings → Mods. They double as examples for
// mod makers: each one is exactly what you would paste into "Add a mod".

export const BUILTIN_MODS = [
  { id: 'builtin-where', code: `// @name Where Am I
// @version 1.0
// @author Tiny Town
// @description Your tile position, zone, layer and how many people are around.
tt.panel({ title: 'Where Am I', width: 180, height: 64 });
let pos = null, around = 0;
const draw = () => {
  if (!pos) return;
  document.body.innerHTML = '<b>' + pos.zone + '</b>' + (pos.layer > 1 ? ' · layer ' + pos.layer : '') +
    '<br>x ' + pos.x.toFixed(1) + ' · y ' + pos.y.toFixed(1) + '<br>' + around + ' people nearby';
};
tt.on('position', p => { pos = p; draw(); });
tt.on('players', p => { around = p.inView; draw(); });` },

  { id: 'builtin-loot', code: `// @name Loot Log
// @version 1.0
// @author Tiny Town
// @description Everything you've found this session, plus a lifetime count kept on this device.
tt.panel({ title: 'Loot Log', width: 220, height: 150 });
const found = [];
let lifetime = 0;
tt.storage.get('lifetime').then(v => { lifetime = v || 0; draw(); });
const draw = () => {
  document.body.innerHTML = '<div style="color:#8a5a1c">Lifetime finds: ' + lifetime + '</div>' +
    (found.length ? found.slice(-8).reverse().map(t => '<div>• ' + t.replace(/[<>&]/g, '') + '</div>').join('') : '<div style="opacity:.6">Nothing yet. Go forage!</div>');
};
tt.on('notice', n => {
  if (n.kind !== 'loot') return;
  found.push(n.text.replace(/^You found /, '').replace(/\\.$/, ''));
  lifetime++; tt.storage.set('lifetime', lifetime); draw();
});
draw();` },

  { id: 'builtin-nightowl', code: `// @name Night Owl Colors
// @version 1.0
// @author Tiny Town
// @description A lavender twilight color scheme, and hides the keyboard hints. No window.
tt.theme({ '--card': '#f4effa', '--ink': '#2e2540', '--muted': '#6f6385', '--line': '#ddd2ee', '--accent': '#8a63c9', '--accent-deep': '#6b48a8' });
tt.hide(['keys', 'chatHint']);` },

  { id: 'builtin-party', code: `// @name Party Pings
// @version 1.0
// @author Tiny Town
// @description Prints a line in your chat when someone joins or leaves your party.
let names = new Set();
tt.on('party', s => {
  const now = new Set((s.party ? s.party.members : []).map(m => m.name));
  for (const n of now) if (!names.has(n) && names.size) tt.print(n + ' joined the party');
  for (const n of names) if (!now.has(n)) tt.print(n + ' left the party');
  names = now;
});` },
].map(m => ({ ...m, ...meta(m.code) }));

function meta(code: string) {
  const tag = (k: string) => (new RegExp(`^\\s*//\\s*@${k}\\s+(.+)$`, 'm').exec(code)?.[1] ?? '').trim();
  return { name: tag('name'), version: tag('version'), author: tag('author'), description: tag('description') };
}
